
// @ts-nocheck
import Vue from "vue";
import Video from "./SVGs/Video.vue";
import { firebase } from '../../../../firebase/firebaseConfig'
const storageRef = firebase.storage().ref()

export default Vue.extend({
  data() {
    return {
      videoURL: "",
      showUploadVideo: false,
      logoLoading: false,
      logoMessage: ""
    }
  },
  props: {
    fieldAddress: Array,
  },
  computed: {
    field: {
      get: function () {
        // @ts-ignore
        return this.$store.getters["survey/stepField"](this.fieldAddress);
      },
      set: function (v) {
        // @ts-ignore
        this.$store.commit("survey/CHANGE_FIELD", {
          // @ts-ignore
          fieldAddress: this.fieldAddress,
          val: v,
        });
      },
    },
  },
  components: {
    Video,
  },
  methods: {
    selectFile() {
      this.$refs.videoInput.click();
    },
    filesChange(target) {
      // NEED TO CROSS BROWSER TEST/READ UP ON FILE API ON BROWSERS/SUPPORT
      //noconsoleconsole.log("checking video validity..");
      this.message = false;
      this.logoMessage = false;
      if (typeof target[0] !== "undefined") {
        let validation = this.validateVideo(target[0]);
        let imgName =
          this.$store.state.dash.viewData.business.businessInfo.businessName +
          (new Date().getTime() / 1000);
        imgName = imgName
          .replace(/[`~±!@#$%^&*()_|+\-=÷¿?;:'",.<> \{\}\[\]\\\/]/gi, "")
          .toLowerCase();
        imgName = imgName.replace(/[^\w\s]/gi, "");
        //console.log(storageRef)
        if (validation.passed) {
          let imageRef = storageRef.child("welcomevideos/" + imgName);
          this.logoLoading = true;
          this.logoMessage = "";
          this.showUploadVideo = false
          this.field = ''
          //noconsoleconsole.log("uploading video..");
          imageRef
            .put(target[0])
            .then((snapshot) => {
              //noconsoleconsole.log("video uploaded");
              snapshot.ref
                .getDownloadURL()
                .then((dURL) => {
                  //noconsoleconsole.log('uploaded, url:')
                  //noconsoleconsole.log(dURL);                                    
                  //noconsoleconsole.log('original filename')
                  this.logoButtonText = target[0].name;
                  this.logoLoading = false
                  this.field = dURL
                  this.$vs.notify({
                    title: 'Welcome video uploaded',
                    text: 'Remember to save your welcome settings by selecting the Check (✔️) button for your Welcome step.',
                    color: 'success',
                    time: 15000,
                    iconPack: 'feather',
                    icon:'icon-check'})
                })
                .catch((e) => {
                  //noconsoleconsole.log(e);
                  this.logoLoading = false;
                  this.logoMessage =
                    "We couldn't upload your logo, please ensure it's not larger than 1MB and either a JPEG, GIF or PNG file.";
                });
            })
            .catch((e) => {
              //noconsoleconsole.log(e);
              this.logoMessage =
                "We couldn't upload your logo, please ensure it's not larger than 1MB and either a JPEG, GIF or PNG file.";
              this.logoLoading = false;
            });
        } else {
          this.logoMessage = validation.reason;
        }
      }
    },
    validateVideo(file) {
      if (typeof file.size !== "undefined") {
        if (file.size > 250000000) {
          return {
            passed: false,
            reason: "Your video file may not be larger than 250MB in size.",
          };
        }
      }
      if (typeof file.size !== "undefined") {
        if (
          file.type !== "video/webm" &&
          file.type !== "video/mp4"
        ) {
          return {
            passed: false,
            reason:
              "Your video file needs to be an MP4 or WebM type.",
          };
        }
      }
      return {
        passed: true,
        reason: "",
      };
    },
  },
});
